export interface AssetTag {
    Id: string;
    AssetTagName: string;
    PartitionKey?: string;
    ClientKey?: string;
}